/* modifyed by slaven 2016.9.23 because of timezone */
import moment from 'moment';
import { get } from 'lodash';
import { getI18nInstance } from '@/scripts/locales/i18nInstance';


export default function formatDate(date, dateOnly) {
    const timezoneInDB = get(window, 'zPREFACE.data.timezone', {});
    const i18n = getI18nInstance();

    const dateFormat = i18n.t('global.format.date');
    const timeFormat = i18n.t('global.format.time');
    const fmt = dateOnly ? dateFormat : `${dateFormat} ${timeFormat}`;
    let str = moment(date).format(fmt);
    if (timezoneInDB && timezoneInDB.utc_offset) {
        let timezoneStr;
        if (typeof date === 'number' && date > 0) {
            let timestampStr = moment.utc(date).format();
            timezoneStr = timestampStr + timezoneInDB.utc_offset;
        } else {
            timezoneStr = date + timezoneInDB.utc_offset;
        }
        let now = moment().utcOffset(timezoneInDB.utc_offset);
        let timezoneTime = moment(timezoneStr)
            .utcOffset(timezoneStr)
            .format(fmt);
        str = timezoneTime.replace(now.format(dateFormat), i18n.t('global.date.today'));
        str = str.replace(now.subtract(1, 'days').format(dateFormat), i18n.t('global.date.yesterday'));
    } else {
        str = str.replace(moment().format(dateFormat), i18n.t('global.date.today'));
        str = str.replace(
            moment()
                .subtract(1, 'days')
                .format(dateFormat),
            i18n.t('global.date.yesterday')
        );
    }
    return str;
}
